import React from 'react'
import {BsLinkedin} from "react-icons/bs"
import { BsGithub } from "react-icons/bs";
import { IoLogoTwitter } from "react-icons/io";
import { FiInstagram } from "react-icons/fi";

import "./header.css"


const HeaderSocials = () => {
  return (
   <div className="header_socials">
      <a href="https://www.linkedin.com/in/alishan-shaikh/" target="_blank" rel="noopener noreferrer"><BsLinkedin className='resume_anim1' /></a>
      <a href="https://github.com/alishaikh9890" target="_blank" rel="noopener noreferrer"><BsGithub className='resume_anim1' /></a>
      <a href="https://twitter.com/Alishan9890" target="_blank" rel="noopener noreferrer"><IoLogoTwitter className='resume_anim1' /></a>
      <a href="https://www.instagram.com/shaikhalishan9890/" target="_blank" rel="noopener noreferrer"><FiInstagram className='resume_anim1' /></a>
     
   </div>
  )
}

export default HeaderSocials